<template>
	<div>
		<triangle-image
			title="Scopri i nuovi snack leggeri e gustosi con i Pavesini"
		/>

		<div class="container">
			<div class="content">
				<section class="paragraph">
					<h2>
						Cosa sono i Pavesini
					</h2>

					<p>
						Tutti li abbiamo assaggiati almeno una volta ma non tutti conosciamo la loro <b>storia</b>. <b>Pavesini</b> classico è il <b>biscotto leggero</b> nato dalla tradizione dei biscottini di Novara, reso famoso dall’esperienza Pavesi e ancora oggi cotto su carta da forno. Pensate che Mario Pavesi lanciò la sua prima produzione dolciaria nel 1937 e dopo gli anni della guerra, capì anche dopo aver studiato il mercato degli Stati Uniti, che c’era spazio per un prodotto più <b>digeribile</b> ma venduto in <b>confezioni comode</b> da portare con sé. Nacquero così i Pavesini che furono resi famosi dalle pubblicità su Carosello con Topo Gigio e il mitico slogan “E’ sempre l’ora dei Pavesini”.
					</p>

					<h2>
						Uno snack leggero e sano
					</h2>

					<p>
						L’apporto ridotto di grassi è uno degli aspetti che rendono i Pavesini una soluzione ideale per chi è alla ricerca di uno snack capace di dare la giusta carica mantenendo una dieta sana ed equilibrata. Pavesini ha infatti <b>solo il 3,5% di grassi e 9 calorie per biscotto</b>. In più per produrli vengono utilizzate solo uova fresche e di categoria A e da galline allevate a terra. Perfetti dunque per leggerezza, qualità e gusto in ogni momento della giornata.
					</p>

					<h2>
						Riscopri il sapore unico dei Pavesini
					</h2>

					<p>
						Scopri le soluzioni pensate per te da Quomi con i Pavesini. Ogni settimana potrai trovare una novità da introdurre nella tua cucina, per uno <b>snack in ufficio</b> o un <b>dessert dopo cena</b>.
					</p>
					
					<slick>
						<template slot="slides">
							<div class='recipe' v-for="(item, index) in extras" :key="index">
								<img :src="item.images.big" :alt='item.title'>
								<div class="recipe-name">{{ item.title }}</div>
							</div>
						</template>
					</slick>
				</section>

				<router-link
                    :to="{ name: 'shop' }"
                    class="flex flex-center"
                >
                    <CTA
                    	isStar
                    	color='orange'
                        :content="`Vai a Colazioni, Pranzi e Sfizi`"
                    />
                </router-link>	
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import TriangleImage from '../TriangleImage'
	import Slick from '../Slick'
	import { goSlick } from '../../assets/js/slick'

	import { ExtraApi } from '../../api/ExtraApi'

	export default {
	components: {
		TriangleImage,
		Slick
	},

	data () {
		return {
			extras: null,
			extrasId: [2464, 2465, 2466, 2461, 2460, 2454]
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	methods: {
		loadExtras () {
			var em = new ExtraApi()
			return em.all({
				params: {
					show: 10,
					page: 1,
					sort_direction: 'asc',
					query: 'id in (' + this.extrasId + ')'
				}
			})

			.then(response => {
				this.extras = response.body.data.resources
			})

			.catch(response => {
			})
		}
	},

	mounted () {
		this.loadExtras()

		.then(response => {
			goSlick()
		})
	}

}
</script>

<style scoped>

.slick-slide >>> .recipe-name.small {
	font-size: 12px;
	text-align: left;
	min-height: 55px;
}

.triangle-image {
	background: url("../../assets/img/covers/pavesini.jpg");
	background-position: center 8%;
	background-repeat: no-repeat;
	background-size: cover;
}


.content {
	max-width: 800px;
}

.paragraph p {
  margin-bottom: 45px;
}

@media (max-width: 1024px) {
	.triangle-image >>> h1 {
		font-size: 30px;
	}
}

</style>
